import {
  createFileRoute,
  useNavigate,
  useSearch,
} from "@tanstack/react-router";
import type { ReactNode } from "react";

import { requireSignedIn } from "../auth/requireSignedIn";
import { InvitePreviewDialog } from "../features/invites/InvitePreviewDialog";
import { InvitesListPane } from "../features/invites/InvitesListPane";
import { validateInvitesSearch } from "../routeState/sectionSearch";
import { SectionScreen } from "../shell/SectionScreen";

const InvitesScreen = (): ReactNode => {
  const search = useSearch({ from: "/pools_/invitations" });
  const navigate = useNavigate({ from: "/pools/invitations" });

  return (
    <SectionScreen heading="Pool invitations">
      <InvitesListPane
        onOpenInvite={(inviteId) => {
          void navigate({ search: (prev) => ({ ...prev, inviteId }) });
        }}
      />
      <InvitePreviewDialog
        inviteId={search.inviteId}
        onClose={() => {
          void navigate({
            search: (prev) => ({ ...prev, inviteId: undefined }),
            replace: true,
          });
        }}
        onGoToPool={(poolId) => {
          void navigate({ to: "/pools", search: { poolId } });
        }}
      />
    </SectionScreen>
  );
};

export const Route = createFileRoute("/pools_/invitations")({
  beforeLoad: requireSignedIn,
  validateSearch: validateInvitesSearch,
  component: InvitesScreen,
});
